
import Admin, { hasRole, Role } from '@/models/Admin'
import Engine from '@/models/Engine'

export default class EnginePolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, engine: Engine) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER,Role.STATION_MANAGER])
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    update(admin: Admin, engine: Engine) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    restore(admin: Admin, engine: Engine) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    delete(admin: Admin, engine: Engine) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    forceDelete(_admin: Admin, _engine: Engine) {
        return false
    }
}
